import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    product: {},
    manageProduct: [],
    setting: null,
    productAvailableTime: null
  },
  mutations: {
    setProductAvailableTime (state, data) {
      state.productAvailableTime = data
    }
  },
  actions: {
    setProductData ({ state }, data) {
      state.product = data
    },
    async getProduct ({ dispatch }, id) {
      const file = `product/item/${id}.json`
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${API.SITE_INFO.site}&file=${file}`)
        dispatch('setProductData', res.data.message)
        return res.data.message
      } catch (ex) {
        console.log(ex.reponse)
        return false
      }
    },
    async getProductSetting ({ state, dispatch }, id) {
      const file = `product/setting.json`
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${API.SITE_INFO.site}&file=${file}`)
        state.setting = res.data.message
        return res.data.message
      } catch (ex) {
        // console.log(ex.reponse)
        return false
      }
    },
    async getManageProduct ({ state }) {
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-commerce-products&id=${API.SITE_INFO.site}`)
        const list = res.data.message ? res.data.message.filter(x => x.inventory !== false) : []
        state.manageProduct = list
        return list
      } catch (ex) {
        return ex.response.data
      }
    }
  },
  getters: {
    getProduct: state => state.product,
    getManageProduct: state => state.manageProduct,
    getProductSetting: state => state.setting,
    getProductAvailableTime: state => state.productAvailableTime
  }
}
